import { render, staticRenderFns } from "./PersonnelRecordsBulkEdit.vue?vue&type=template&id=2dc99181"
import script from "./PersonnelRecordsBulkEdit.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordsBulkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports